<template>
    <v-container v-if="this.zamawiajacy" class="page">
  <table>
    <thead>
    <tr><td>
  
  <div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
    <div class="left-cointainer">
      <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
    </div>
    <div class="right-cointainer">
      Tutore Poland Sp. z o.o.<br>
      ul. Piotrkowska 157A, 90-440 Łódź<br>
      NIP: 7272812193
    </div>
  </div>
   
    </td></tr>
    </thead>
  <tbody>
  <tr><td>
  
  <p align="center" style="margin-top:20px;">
      <strong>ANEKS DO UMOWY O PRACĘ</strong> <br>
      <strong>z dnia {{dataUmowy}} roku</strong>
  </p>
  <p>
      Zawarty w dniu {{dataAneksu}}  roku pomiędzy:
  </p>
  <p>
    <strong>Tutore Poland Sp. z o.o.</strong>, z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, wpisaną do Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla Łodzi Śródmieścia, XX Wydział Krajowego Rejestru Sądowego pod nr KRS 0000670834, NIP: 727-28-12-193, REGON: 366891567, kapitał zakładowy 6 481 900,00 zł, 
    zwaną dalej <strong>PRACODAWCĄ</strong>, <br>
    reprezentowaną przez: 
  </p>
  <p>
    <strong>{{zamawiajacy}}</strong>,
  </p>
  <p>a</p>
  
    Imię i nazwisko: {{imieNazwisko}}
    <br/>
    Pesel: {{pesel}}
    <br/>
    Adres: {{zamieszkany}}
    <br/>
    <br/>
    zwanym dalej <strong>PRACOWNIKIEM</strong>
    <br/>
    <br/>
  <p>
    1.  Rodzaj umówionej pracy: {{ rodzajPracy }}, <strong>przy czym praca będzie wykonywana z wykorzystaniem środków komunikacji elektronicznej w rozumieniu przepisów o świadczeniu usług drogą elektroniczną.</strong>
    </p>
    <p>
    {{ miejscePracy1 }}. 
  </p>
  <p>
    {{ miejscePracy2 }}. 
  </p>
  <p>Pozostałe warunki umowy wraz z jej załącznikami pozostają bez zmian.</p>
  <p>Postanowienia aneksu wchodzą w życie z dniem: {{ dataStartuAneksu }}.</p>
  <p>Niniejszy aneks został sporządzona w dwóch jednobrzmiących egzemplarzach, jeden dla Pracodawcy, jeden dla Pracownika.</p>

  <br/>
    <br/>
    Data:
    <br/>
    <br/>
  
  <div class="cointainer" style="margin-top: 30px;">
      <div class="left-cointainer">
        <span style="margin-left: 0%;">Podpis pracodawcy</span>
      </div>
      <div class="right-cointainer">
          <span style="margin-left: 0%;">Podpis pracownika</span>
      </div>
  </div>
  
  
    </td></tr>
    </tbody></table>
  
    </v-container>
  </template>
  
  <script>
   export default {
    name: 'AneksMiejsceRodzajPracyUOP',   
  data () {
    return {
        zamawiajacy: '',
        imieNazwisko: '',
        zamieszkany: '',
        korespondencyjny: '',
        pesel: '',
        kwota: '',
        wypo: '',
        slownie: '',
        kwotapokaz: '',
        slowniepokaz: '',
        rodzajPracy: '',
        miejscePracy: '',
        dataAneksu: '',
        dataUmowy: '',
        dataStartuAneksu: '',
      }
    },
    created () {
      Object.entries(this.$route.query).forEach(
        ([key, value]) => { this[key] = value }
      )
    },
    methods: {
    },
    mounted () {
      if (this.zamawiajacy) {
        this.$nextTick(() => {
          window.setTimeout(() => {
            const currentURL = window.location.href
            history.replaceState(history.state, '', '/')
            window.print()
            history.replaceState(history.state, '', currentURL)
          }, 300)
        })
      }
    }
  }
  </script>
  
  <style scoped>
  .page {
    size: 210mm 297mm;
    background-size: 100% 100%;
    line-height: 1.4;
    text-align: justify;
    margin-top: 2px;
    padding-top: 0px;
  }
  table {
    border: 1px;
    border-collapse: collapse;
    table-layout: fixed;
  }
  th, td {
    border: 1px;
    border-collapse: collapse;
  }
  .cointainer {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .cointainer-left {
    width: 20%;
  }
  .cointainer-right {
    width: 20%;
  }
  thead {
    display: table-header-group;
  }
  .table-border {
    border: 1px solid black;
    border-collapse: collapse;
    padding: 5px;
  }
  .cell-in-first-table {
    margin-top: 2px;
    margin-bottom: 2px;
    margin-left: 10px;
    margin-right: 10px;
  }
  ul.dashed {
    list-style-type: "- ";
    margin: 0;
  }
  .underline {
    text-decoration: underline;
  }
  .pageNum {
    position: absolute;
    right: 0px;
    font-size: 14px;
  }
  #oswiadczenie {
    padding: 20px;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/AneksMiejsceRodzajPracyUOP.vue